<nav class="footer-nav"
  role="navigation"
  *transloco="let t; read: 'mini-footer'"
  [attr.aria-label]="t('aria_accredible_links')">
  <ul>
    <li>
      <a href="https://www.accredible.com/terms/"
        target="_blank"
        data-cy="tos-link"
        [attr.aria-label]="t('aria_terms_of_service')">
        {{ t('terms_of_service') }}
      </a>
    </li>
    <li>
      <a href="https://www.accredible.com/data-privacy/"
        target="_blank"
        data-cy="policy-link"
        [attr.aria-label]="t('aria_privacy_policy')">
        {{ t('privacy_policy') }}</a>
    </li>
  </ul>
</nav>

<accredible-language-selector [languages]="languages"/>